import React, { useEffect, useState } from "react";
import { Grid, Card } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "react-responsive";
import { CardContent } from "@material-ui/core";
import EnergyPlansHeader from "./e_tariff_plans/view/e_header";
import Components from "../e_sustainability/e_components";
import E_LowestRatePlan from "./e_tariff_plans/view/e_your_lowest_plan";
import { useSelector } from "react-redux";

const useStyle = makeStyles((theme) => ({
  main:{
     height: "100%"
  },
  cardContentPadding:{
    paddingTop:"0.3rem",
    paddingBottom:"0.3rem !important",
    height: "100%"
  },
  mainGrid: {
    flexFlow: "column",
    height: "100%"
  },
  contentGrid: {
    flexGrow: "1",  
  }
}));

export default function Sustainability() {
  let classes = useStyle();
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  return (
    <>
        <Card className={classes.main} style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}>
        <CardContent className={classes.cardContentPadding}>
          <Grid container className={classes.mainGrid}>
            <Grid item>
              <EnergyPlansHeader/>
            </Grid>
            <Grid item className={classes.contentGrid}>
              <E_LowestRatePlan/>
            </Grid>
          </Grid>          
        </CardContent>
      </Card>
    </>
  );
}